export function hasMatchingBrackets(
  value: string,
  [start, end] = ['{', '}']
): boolean {
  const stack = [];
  let unopen = 0;
  for (let i = 0; i < value.length; i++) {
    if (value[i] === start) {
      stack.push(value[i]);
    } else if (value[i] === end) {
      if (stack.length === 0) {
        unopen += 1;
      } else {
        stack.pop();
      }
    }
  }
  return stack.length + unopen === 0;
}
